import React from 'react';
import { Button, Item, ItemActions, ItemContent, ItemMedia } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

export interface ProfileMenuItemProps {
    id?: string;
    menuItemChildren?: React.ReactNode;
    menuItemLabel: string;
    icon?: React.ReactNode;
    labelClassName?: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void | Promise<void>;
    disabled?: boolean;
    className?: string;
}

const ProfileMenuItem: React.FC<ProfileMenuItemProps> = ({
    id,
    menuItemLabel,
    icon,
    menuItemChildren,
    labelClassName,
    className,
    disabled,
    onClick,
}) => {
    return (
        <Item variant="default" size="xs" className={className} asChild>
            <Button id={id} variant="ghost" size="sm" disabled={disabled} onClick={onClick}>
                {icon && (
                    <ItemMedia data-icon="inline-start" variant="icon" className="shrink-0">
                        {icon}
                    </ItemMedia>
                )}
                <ItemContent className={cn('min-w-0 flex-1 flex-row items-center gap-2', labelClassName)}>
                    {menuItemLabel}
                </ItemContent>
                {menuItemChildren && (
                    <ItemActions data-icon="inline-end" className="shrink-0">
                        {menuItemChildren}
                    </ItemActions>
                )}
            </Button>
        </Item>
    );
};

export default ProfileMenuItem;
